import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../core/guards/role.guard';
// Component pages
import { DashboardComponent } from "./dashboards/dashboard/dashboard.component";
import { IncidentCreateComponent } from './incidents/incident-create.component';
import { IncidentListComponent } from './incidents/incident-list.component';
import { VehicleAssignmentComponent } from './incidents/vehicle-assignment.component';
import { CrewAssignmentComponent } from './incidents/crew-assignment.component';
import { LiveTrackingComponent } from './live-tracking/live-tracking.component';
import { VehicleListComponent } from './incidents/vehicle-list.component';
import { EmployeesComponent } from './incidents/employees/employees.component';
const routes: Routes = [
    
    {
      path: '', redirectTo: '/incidents', pathMatch: 'full'
    },
    {
      path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
    },
    {
      path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule)
    },
    {
          path: 'dashboard', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
    },
    // {
    //   path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
    // },
    // {
    //   path: 'tasks', loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)
    // },
    // {
    //   path: 'crm', loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
    // },
    // {
    //   path: 'crypto', loadChildren: () => import('./crypto/crypto.module').then(m => m.CryptoModule)
    // },
   
    { path: 'incidents/create', component: IncidentCreateComponent , canActivate: [RoleGuard], data: { roles: ['admin'] } },
    { path: 'incidents', component: IncidentListComponent },
    { path: 'vehicles', component: VehicleListComponent },
    { path: 'incidents/:id', component: VehicleAssignmentComponent   },
    { path: 'incidents/:id/assign-crew', component: CrewAssignmentComponent , canActivate: [RoleGuard], data: { roles: [ 'admin','fire_station'] } } ,
    { path: 'live-tracking', component: LiveTrackingComponent },
    { path: 'employees', component: EmployeesComponent , canActivate: [RoleGuard], data: { roles: ['admin','fire_station'] } },
    {
      path: 'pages', loadChildren: () => import('./extrapages/extraspages.module').then(m => m.ExtraspagesModule)
    },
    { path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UiModule) },
    {
      path: 'advance-ui', loadChildren: () => import('./advance-ui/advance-ui.module').then(m => m.AdvanceUiModule)
    },
    {
      path: 'forms', loadChildren: () => import('./form/form.module').then(m => m.FormModule)
    },
    {
      path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
    },
    // {
    //   path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsModule)
    // },
    {
      path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)
    },
    // {
    //   path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule)
    // },
    // {
    //   path: 'marletplace', loadChildren: () => import('./nft-marketplace/nft-marketplace.module').then(m => m.NftMarketplaceModule)
    // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
